import { render, staticRenderFns } from "./SiXiang.vue?vue&type=template&id=29dbb458&scoped=true&"
import script from "./SiXiang.vue?vue&type=script&lang=js&"
export * from "./SiXiang.vue?vue&type=script&lang=js&"
import style0 from "./SiXiang.vue?vue&type=style&index=0&id=29dbb458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbb458",
  null
  
)

export default component.exports